import React, { useContext, useState } from "react";
import { Avatar, Card, CardMedia, Grid, IconButton, Stack } from "@mui/material";

import HomeIcon from '@mui/icons-material/Home';

import AppMenu from "./AppMenu";
import CurrentUserContext from "@/Contexts/CurrentUser";
import { BLUE } from "@/theme/palette";
import Notification from "./Notification";
import { getInitials } from "@/utils/userInformation";
import StyledServiceMenu from "./StyledServiceMenu";
import SelfServiceMenu from "./SelfServiceMenu";
import { rootRouteModeVar } from "@/router/reactiveRoutes";
import { useReactiveVar } from "@apollo/client/react";
import SharePointConnector from "./SharePointConnector";
import FeedbackModal from "./FeedbackModal";
import SettingsModal from "./SettingsModal";
import SettingsContextProvider from "@/Contexts/Settings/Provider";

const IS_PLAYGROUND = window.location.hostname.includes('playground')

const Navbar: React.FC = () => {
  const { currentUser } = useContext(CurrentUserContext);
  const [serviceMenuAnchor, setServiceMenuAnchor] = useState<HTMLDivElement | null>(null)
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const mode = useReactiveVar(rootRouteModeVar);

  const handleClickHomeButton = () => window.location.href = '/';

  const handleModalShow = (actionName: 'createEvent' | 'createProject' | 'createKickOff' | 'showSettings' | 'createFeedback') => {

    switch (actionName) {
      case 'createEvent':

        break;
      case 'createProject':

        break;
      case 'createKickOff':

        break;
      case 'showSettings':
        setShowSettings(true)
        break;
      case 'createFeedback':
        setShowFeedbackModal(true)
        break;
      default: null
    }

  };

  console.log('window.location.hostname', window.location.hostname)

  return (
    <Grid
      container
      sx={{ backgroundColor: IS_PLAYGROUND ? '#000' : BLUE, paddingX: 3 }}
      height={55}
      id="navbar"
      justifyContent='space-between'
      alignItems='center'
      size={12}>
      <AppMenu />
      <Grid container spacing={1}>
        <Card sx={{ maxWidth: 190, backgroundColor: 'transparent', cursor: 'pointer' }} elevation={0}>
          <CardMedia
            component="img"
            width="190"
            image="https://overwatch-prod.lon1.digitaloceanspaces.com/Overwatch%20Primary%20Logo%20Wordmark%20White.png"
            alt="overwatch logo white"
            sx={{ marginTop: '8px' }}
            onClick={() => window.location.href = "https://theoverwatch.ai"}
          />
        </Card>
      </Grid>
      <Stack direction="row" alignItems="center">
        <SharePointConnector />
        {(mode === 'manager' || mode === 'scheduler') &&
          <IconButton onClick={() => handleClickHomeButton()}>
            <HomeIcon sx={{ color: "white" }} />
          </IconButton>
        }
        <Notification />
        <Avatar
          src={currentUser?.imageUrl as string}
          onClick={(event) => setServiceMenuAnchor(event.currentTarget)}
          sx={{ marginLeft: 2, width: 40, height: 40, cursor: 'pointer' }}
        >
          {getInitials(currentUser?.firstName, currentUser?.lastName)}
        </Avatar>
      </Stack>
      {
        Boolean(serviceMenuAnchor) &&
        <StyledServiceMenu
          id="self-service-menu"
          anchorEl={serviceMenuAnchor}
          open
          onClose={() => setServiceMenuAnchor(null)}
        >
          <SelfServiceMenu openFeedbackModal={() => handleModalShow('createFeedback')} showSettingsModal={() => handleModalShow('showSettings')} />
        </StyledServiceMenu>
      }
      {showFeedbackModal && <FeedbackModal handleClose={() => setShowFeedbackModal(false)} />}
      {mode !== 'super' &&
        <SettingsContextProvider>
          <SettingsModal open={showSettings} handleClose={() => setShowSettings(false)} />
        </SettingsContextProvider>
      }

    </Grid >
  );
};

export default Navbar;
